export default __webpack_public_path__ + "static/media/previewinactivecategorybanner.1c12a254.png";